import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { buildAsturHeaders } from '@/endpoints/channel/asturHeaders';
import { utils } from '@/utils';
import type { CommonalityData, CommonalitySubscriptionGetResponse } from '@/types/commonality';
import type { ChannelApiResponse } from '@/types/endpoints';
import type { ReadRequestOptions } from '../../requestOptions';

function isObject(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === 'object' && !Array.isArray(value);
}

export async function getSubscriptionCommonality(
  scope: RequestScope,
  args: { subscriptionId: number | string; signal?: AbortSignal },
  options: ReadRequestOptions
): Promise<ChannelApiResponse<CommonalityData>> {
  try {
    const res = await scopedChannelApi(scope).get<CommonalitySubscriptionGetResponse>('atts/commonality/subscription', {
      ...options,
      headers: buildAsturHeaders({ subscriptionId: args.subscriptionId }),
      signal: args.signal ?? options.signal,
    });

    const raw = res.data as unknown;
    if (!isObject(raw)) {
      throw new Error('Invalid commonality response');
    }

    const data = raw['data'];
    if (!isObject(data)) {
      throw new Error('Invalid commonality response');
    }

    return {
      data: data as CommonalityData,
      status: res.status,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
